export default __webpack_public_path__ + "images/error-icon.0a8b5a76.svg";